module.exports = __webpack_public_path__ + "img/image1.1e54753e.jpg";